<template>
  <div class="InsuranceTypeForm">
    <h2 class="gl_form-title">
      {{ t(`copy_life_insurance-type_form-title-${answers.forWhom ?? 'me'}`) }}
    </h2>

    <RadioButtonGroup
      id="main"
      :value="insuranceType"
      :options="insuranceTypes"
      v-model="insuranceType"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import type LifeConfigurations from '@/modules/life/common/models/APP/LifeConfigurations'

const { t } = useI18n()

defineExpose({ triggerSubmit })
interface PropsInterface {
  nextForm: String[]
  answers: Record<string, any>
  configurations: LifeConfigurations
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const insuranceTypes = props.configurations.getInsuranceTypesOptions(props.answers.forWhom)

const insuranceType = ref(props.answers.insuranceType ?? props.configurations.defaultInsuranceType)

function triggerSubmit() {
  const page = props.nextForm[0]

  const insuranceTypeHasChanged = (Number(props.answers.insuranceType) !== Number(insuranceType.value)) 
  if (insuranceTypeHasChanged) {
    const insureds =props.answers.insureds
    insureds[0].additionalCoverages = []

    const answers = {
      insuranceType: insuranceType.value,
      insureds
    }

    return { page, answers }
  }

  const answers = {
    insuranceType: insuranceType.value
  }

  return { page, answers }
}
</script>

<style lang="scss" scoped>
.InsuranceTypeForm {
  .RadioButtonGroupComponent {
    margin-bottom: $spacing-l;

    :deep(.ErrorMessageComponent) {
      display: none;
    }
  }
}
</style>
